import _ from 'lodash'
import { Languages } from 'i18n'

export interface Font {
  name: string;
  text: string[];
}

/**
 * 提取字体与对应文本
 */
export function pickFontAndText(
  languages: Languages
): Font[] {
  const fontList: {
    [key: string]: {
      name: string; // fontName
      text: string[];
    };
  } = {}
  _.each(languages, language => {
    _.each(language, text => {
      const font = text?.style?.font
      if (font) {
        fontList[font] = fontList[font] || {
          name: font,
          text: []
        }
        fontList[font].text.push((_.get(text, 'value') || '') as string)
      }
    })
  })

  return Object.values(fontList).map(font => ({ ...font }))
}
